import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CustomModal from '../common/CustomModal';
import t from '../../translations';

const SessionLost = ({ exists, wasLoggedIn }) => {
    if (!(!exists && wasLoggedIn)) {
        return null;
    }

    return (
        <CustomModal className="session-lost" closeHandler={() => null} title={t.user.sessionExpired} buttons={[]}>
            <p>{t.user.lostSession}</p>
        </CustomModal>
    );
};

SessionLost.propTypes = {
    exists: PropTypes.bool.isRequired,
    wasLoggedIn: PropTypes.bool.isRequired,
};

export default connect((state) => ({
    exists: state.user.exists,
    wasLoggedIn: state.user.wasLoggedIn,
}))(SessionLost);
